// eslint-disable-next-line no-restricted-imports
import { getImageByToken as getChimeAssetsImageByToken, type ImageToken, type PixelRatio } from '@1debit/chime-assets';
// eslint-disable-next-line no-restricted-imports
import { getIconByKey as getChimeAssetsIconByKey, type IconToken } from '@1debit/icons';

export const getIconByKey = (key: IconToken) => {
	try {
		return getChimeAssetsIconByKey(key);
	} catch (error) {
		console.error('Could not get icon', { key, error });
		return undefined;
	}
};

export const getImageByToken = (token: ImageToken, pixelRatio: PixelRatio = 3) => {
	try {
		return getChimeAssetsImageByToken(token, pixelRatio);
	} catch (error) {
		console.error('Could not fetch image', { token, pixelRatio, error });
		return undefined;
	}
};
